import styled from 'styled-components'

export const VendorLogoBadgeMarkStyled = styled.img<{ $height: number }>`
  display: block;
  width: auto;
  height: ${(props) => props.theme.typography.pxToRem(props.$height)};
`
